import React from 'react';
import { Container } from 'components/UI';
import { Title } from '@landing/ui';
import ProgramItems from './ProgramItems';
import { getMeetupDateString } from 'utils';

import * as styles from './EventProgram.module.scss';

export default function EventProgram({ title, items }) {
  const date = getMeetupDateString({
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
  const dateAndTime = `${date}, 10 AM (Chicago) | 4 PM (London) | 5 PM (Berlin) | 7 PM (Dubai)`;

  return (
    <Container id="program" className={styles.container} background="transparent">
      <div className={styles.layout}>
        <Title color="white">{title}</Title>
        <p className={styles.subtitle}>{dateAndTime}</p>
        <div className={styles.itemsWrapper}>
          <ProgramItems items={items} />
        </div>
      </div>
    </Container>
  );
}
